import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }

import { PlusIcon } from "@heroicons/vue/24/solid";
import { QueryValueFormattingRule, QueryValueMetric } from "@/types/reports/PlotQueryValue";
import QueryValueFormattingRuleField from "@/views/reports/plots/query_value/QueryValueFormattingRuleField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QueryValueFormattingRules',
  props: {
    metric: {},
    rules: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const handleAddRuleClick = () => {
  const rule: QueryValueFormattingRule = {
    action: "green_background",
    value: null,
    operator: "greater",
  };
  emit("update", [...props.rules, rule]);
};

const handleDeleteRule = (ruleIndex: number) => {
  emit(
    "update",
    props.rules.filter((rule, index) => index !== ruleIndex),
  );
};

const handleUpdateRule = (ruleIndex: number, updatedRule: QueryValueFormattingRule) => {
  emit(
    "update",
    props.rules.map((rule, index) => (index == ruleIndex ? updatedRule : rule)),
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex flex-col gap-1",
        key: index
      }, [
        _createVNode(QueryValueFormattingRuleField, {
          metric: _ctx.metric,
          rule: rule,
          onDelete: ($event: any) => (handleDeleteRule(index)),
          onUpdate: ($event: any) => (handleUpdateRule(index, $event))
        }, null, 8, ["metric", "rule", "onDelete", "onUpdate"])
      ]))
    }), 128)),
    _createVNode(_unref(PlusIcon), {
      class: "w-5 h-5 cursor-pointer",
      onClick: handleAddRuleClick
    })
  ]))
}
}

})